'use client'
import React, { createRef } from "react";

export default class OTP extends React.Component {
    constructor(props) {
        super(props);
        this.OTP_LENGTH = 5;
        this.state = {
            inputArr: new Array(this.OTP_LENGTH).fill("")
        };
        this.inputRefs = Array.from({ length: this.OTP_LENGTH }, () => createRef());
    }

    componentDidMount() {
        if (this.inputRefs[0] && this.inputRefs[0].current) {
            this.inputRefs[0].current.focus();
        }
    }

    handleChange = (value, index) => {
        let newValue = value.trim();
        if (isNaN(value)) return;

        const inputArr = [...this.state.inputArr];
        inputArr[index] = newValue.slice(-1);
        this.setState({ inputArr }, () => {
            if (value && this.inputRefs[index + 1] && this.inputRefs[index + 1].current) {
                this.inputRefs[index + 1].current.focus();
            }
        });
        this.props.handleOTP(inputArr.join(""));
    };

    handleOnKeyDown = (e, index) => {
        if (!e.target.value && e.key === "Backspace") {
            if (this.inputRefs[index - 1] && this.inputRefs[index - 1].current) {
                this.inputRefs[index - 1].current.focus();
            }
        }
    };

    render() {
        return (
            <>
                <div className="w-40">
                    {this.state.inputArr.map((input, index) => (
                        <input
                            key={index}
                            className="input_style"
                            value={this.state.inputArr[index]}
                            ref={this.inputRefs[index]}
                            onChange={(e) => this.handleChange(e.target.value, index)}
                            onKeyDown={(e) => this.handleOnKeyDown(e, index)}
                        />
                    ))}
                </div>
            </>
        );
    }
}
